import React from "react"
import { DropdownButton } from 'react-bootstrap'
import { MenuItem } from "./MenuItem"

export function App({ transcripts, fileref }) {
  let transcript_components = transcripts.map((i) => <MenuItem key={`${fileref}-${i['file_type']}`} fileref={fileref} filetype={i['file_type']} title={i['title']} />)

  return <div className="my-2 pull-right">
    <DropdownButton
      title="Transcripts"
      key={fileref}
      id={`dropdown-basic-${fileref}`}
      pullRight
      className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
      aria-label="Download format options"
      download
    >
      {transcript_components}
    </DropdownButton>
  </div>
}

